import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { Conversation, Escalation } from 'src/models';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { ConversationsService } from 'src/services/conversations.service';

@Component({
  selector: 'app-conversation-chip',
  templateUrl: './conversation-chip.component.html',
  styleUrls: ['./conversation-chip.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, SharedPipesModule, RouterModule],
})
export class ConversationChipComponent implements OnInit {
  @Input() conversationId: string;
  @Input() escalationId: string;

  conversation: Partial<Conversation>;
  escalation: Partial<Escalation>;

  constructor(private conversationsService: ConversationsService) {}

  async ngOnInit() {
    const conversation = await this.conversationsService.get(this.conversationId);

    if (conversation && this.escalationId) {
      this.escalation = conversation.escalations.find((escalation) => escalation.id === this.escalationId);
    }

    this.conversation = conversation;
  }
}
